import React from "react";
import { Outlet, Link, useParams } from 'react-router-dom';
import { useEffect, useState } from "react";
import { Signature, ethers } from "ethers";
import { contractAddresses } from '../../web3/contractsAddresses';
import Background from "../background";
import styled from 'styled-components';
import Board1 from '../img/board1.jpg';
import Board2 from '../img/board2.jpg';
import Board3 from '../img/board3.jpg';
import Board4 from '../img/board4.jpg';
import BoardHash from '../img/board_hash.jpg';
import BoardSeal from '../img/board_seal.jpg';
import BoardScreen from '../img/board_screen.jpg';
import BoardPB from '../img/board_pb.jpg';
import BoardSlot from '../img/board_slot.jpg';
import BoardSenior from '../img/board_senior.jpg';
import BoardTrick from '../img/board_trick.jpg';
import BoardAway from '../img/board_away.jpg';
import BoardSuit from '../img/board_suit.jpg';
import BoardDivert from '../img/board_divert.jpg';
import VideoPlayer from "../videoPlayer";


const utilities = require("../utilities");

function CypherBoards() {
    return (
        <div className="ProjectInfo">
            <p className="highlightInfo">CYPHERBOARDS</p>
            <VideoPlayer src="https://felixfelixfelix.com/files/TrickBox_1080.mp4" autoPlay={true} loop={true} />
            <div className="descriptionDiv">
                <p className="starter">At the intersection of the digital and physical realm, always stands a computer.</p>
                <p>These artworks are cypherdudes that has been taken off the ethereum blockchain (the world computer), and materialized into a single board computer.</p>
                <p>The digital nature of the original medium, the ethereum blockchain, is ported and hard coded into this computer sculpture using c++ language.</p>
                <p>In this series of 16 boards, 6 of them are different. They are called the "Basel Editions"., first shown at the Digital Art Mile organized by Art Meta during Art Basel 2025. They include a concealed seed phrase : a recovery key to access a blockchain wallet. This wallet contains the corresponding cypherdude and its cypherpalace.</p>
                <p>The other editions, called the "Holders Editions", are made upon request from cypherdudes holders and will not get this feature.</p>
                <p>Each board contains two screens, two buttons, two battery slots, two USB-C ports, one to charge the batteries, the other to connect the board to a computer.</p>
                <p>By using the buttons, the large 4" screen alternatively displays the cypherdude or its console. The small 1.3" screen shows additional data about the work.</p>
                <p>240 pins (DDR2 SDRAM standard layout), and three protoboards areas complete the setup in order to allow future evolutions of this computer sculpture.</p>
            </div>
            <div className="imgGrid">
                <div className="imgThumb2">
                    <VideoPlayer src="https://felixfelixfelix.com/files/cypherboards.mp4" width="100%" height="95%" autoPlay={true} loop={true} />
                    <p className="captionText"></p>
                </div>
                <div className="imgThumb2">
                    <img className="Img100" src={Board1} />
                    <p className="captionText"></p>
                </div>
                <div className="imgThumb2">
                    <img className="Img100" src={Board2} />
                    <p className="captionText"></p>
                </div>
                <div className="imgThumb2">
                    <img className="Img100" src={Board3} />
                    <p className="captionText"></p>
                </div>
                <div className="imgThumb2">
                    <img className="Img100" src={Board4} />
                    <p className="captionText"></p>
                </div>
            </div>
            <p>FEATURES</p>
            <div className="imgGrid">
                <div className="imgThumb2">
                    <img className="Img100" src={BoardHash} />
                    <p className="captionText">This engraved hash is an encrypted message decided by the owner</p>
                </div>
                <div className="imgThumb2">
                    <img className="Img100" src={BoardScreen} />
                    <p className="captionText">The 4" screen displays alternatively the cypherdudes and the console</p>
                </div>
                {/* <div className="imgThumb2">
                    <img className="Img100" src={BoardScreen} />
                    <p className="captionText">The 1.3" screen displays alternatively diagrams and textual descriptions</p>
                </div> */}
                <div className="imgThumb2">
                    <img className="Img100" src={BoardSeal} />
                    <p className="captionText">The engraved seed phrase on the steel plate is concealed with a tamper proof seal</p>
                </div>
                <div className="imgThumb2">
                    <img className="Img100" src={BoardPB} />
                    <p className="captionText">The protoboards area will allow to plug future circuit extension</p>
                </div>
            </div>
            <p>COLLECTION</p>
            <p>Basel Editions</p>
            <div className="imgGrid">
                <div className="imgThumb">
                    <img className="Img100" src={BoardAway} />
                    <p className="TokenName">AWAY - CYPHERBOARD 3/16</p>
                </div>
                <div className="imgThumb">
                    <img className="Img100" src={BoardSenior} />
                    <p className="TokenName">SENIOR - CYPHERBOARD 4/16</p>
                    <p className="captionText">(available - contact me for enquiry)</p>
                </div>
                <div className="imgThumb">
                    <img className="Img100" src={BoardTrick} />
                    <p className="TokenName">TRICK - CYPHERBOARD 5/16</p>
                </div>
                <div className="imgThumb">
                    <img className="Img100" src={BoardSuit} />
                    <p className="TokenName">SUIT - CYPHERBOARD 6/16</p>
                </div>
                <div className="imgThumb">
                    <img className="Img100" src={BoardSlot} />
                    <p className="TokenName">SLOT - CYPHERBOARD 7/16</p>
                </div>
                <div className="imgThumb">
                    <img className="Img100" src={BoardDivert} />
                    <p className="TokenName">DIVERT - CYPHERBOARD 8/16</p>
                </div>
            </div>
            <p>Holder Editions</p>
            <p>... currently in production</p>
        </div>
    )
}

export default CypherBoards;